import React from 'react'
// @ts-ignore no types
import { Text, constants, useApplicationContext } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import {
  PATH_CONFIG,
  getPurchasePaths,
  type PurchasePath,
} from 'common/utils/listingPaths'
import classnames from 'classnames/bind'
import analytics from 'common/services/analytics'
import PathOptionList from '../pathOptionList'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)
const { ColorNames } = constants

/**
 * "Choose a Way to Buy" — inline path selector for the unified PDP. Surfaces in
 * the bid-box column when a property has more than one purchase path (and the
 * flag is on), letting the buyer switch between them.
 */
export const ChooseWayToBuyComponent = () => {
  const { featureFlags } = useApplicationContext()
  const { listing, activeListings, listingActions } = useListingContext()

  const unifiedPdpEnabled = featureFlags?.['fe.resi.enable-unified-pdp']
  const paths = getPurchasePaths(activeListings)

  if (!unifiedPdpEnabled || paths.length < 2) return null

  const switchToPath = ({ type, listing: target }: PurchasePath) => {
    if (target.listing_id === listing?.listing_id) return
    analytics.dualTrack.pathSelected({
      path: PATH_CONFIG[type].analyticsPath,
      source: 'toggle',
    })
    listingActions?.setCurrentListingId(target.listing_id)
  }

  return (
    <div className={cx('choose-way')} data-elm-id='choose-a-way-to-buy'>
      {/* letterSpacing: not a DS Text prop */}
      <Text
        as='span'
        size='tiny'
        weight='heavy'
        color={ColorNames.Gray}
        style={{ letterSpacing: '0.98px' }}
      >
        CHOOSE A WAY TO BUY
      </Text>
      <PathOptionList
        paths={paths}
        elmIdPrefix='choose-a-way-to-buy'
        onSelect={switchToPath}
        selectedListingId={listing?.listing_id}
      />
    </div>
  )
}

export default ChooseWayToBuyComponent
